import styled from "styled-components";
import {GaugeCenter, GaugeTrack} from "./ProgressCard.styles";

/**
 * The live card's ring (kitecorp/transferify-ui#3320): the hosted upload's gauge geometry (`ProgressCard.styles`:
 * the 200-unit box, the radius-90 path from 12 o'clock and its 14-unit stroke), cut into one arc per recipient.
 * 140px across on every card width (owner decision, kitecorp/transferify-ui#3341: the 200px ring was too big, and
 * the card with two recipients has to fit a 1366x768 window). The stroke is in the box's own units, so it scales
 * with the diameter.
 */
export const RingBox = styled.div`
	position: relative;
	width: min(100%, 140px);
	margin: 0 auto 2px;
`;

/**
 * The centre, wider than the upload gauge's: the speed is one line that must not wrap, and at 140px the gauge's
 * 18% inset leaves it 90px, too narrow for a three-digit figure and its unit. 12% leaves 106px, which stays inside
 * the stroke's inner edge at the height the two lines sit.
 */
export const RingCenter = styled(GaugeCenter)`
	inset: 12%;
	gap: 3px;
`;

/** An arc's empty track. Round caps like the fill's, so an arc reads as one piece with a gap either side. */
export const ArcTrack = styled(GaugeTrack)`
	stroke-linecap: round;
`;

/**
 * An arc's fill, in the progress role (`progressFill`), the same colour for every recipient. The dash moves as the
 * recipient's percent does; eased like the upload's ring, and still for a reader who asked for less motion.
 */
export const ArcFill = styled(GaugeTrack)`
	stroke: ${({theme}) => theme.tokens.progressFill};
	stroke-linecap: round;
	transition: stroke-dasharray 0.7s ease;

	@media (prefers-reduced-motion: reduce) {
		transition: none;
	}
`;

/**
 * The combined speed, a large figure beside a small unit, as the upload's percentage sits in its ring. Sized for
 * the 140px ring: "999.99 MB/s", the widest a rung shows before the next one takes over, stays inside the stroke.
 */
export const Speed = styled.span`
	display: flex;
	align-items: baseline;
	gap: 3px;
	font-weight: 700;
	line-height: 0.95;
	letter-spacing: -0.045em;
	font-variant-numeric: tabular-nums;
	white-space: nowrap;

	& > b {
		font-size: 23px;
		font-weight: 700;
	}

	& > span {
		font-size: 12px;
		letter-spacing: -0.01em;
	}
`;
